<template>
  <v-container fluid class="org-pricing mb-12">
    <v-row>
      <v-col cols="11">
        <v-row class="checkout-page__back my-2 mr-0 mt-10" justify="end">
          <v-btn text color="#3badff" @click="onBackClick">
            <v-icon class="checkout-page__back-icon">mdi-arrow-left</v-icon>
            <span class="checkout-page__back-text">Volver</span>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <Prices context="dashboard" />
  </v-container>
</template>

<script>
import Prices from "@/components/Prices";
import { meta, tools } from "@/libs/mixins";

export default {
    name: "OrganizationPricing",

    components: {
        Prices,
    },

    mixins: [tools, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Planes y precios",
        });
    }, 

    methods: {
        onBackClick() {
            this.$router.go(-1);
        }
    },
};
</script>
